// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"535":"login","998":"chunk-vendors"}[chunkId] + "." + {"535":"3681beab","998":"cb939f70"}[chunkId] + ".css";
};